const DOMAIN_TITLE_MAP = {
  'www.sctp.com.tr': 'Sun Chemical – Dış Ticaret Entegre Yönetim Platformu',
  'sctp.com.tr': 'Sun Chemical – Dış Ticaret Entegre Yönetim Platformu',
  'bigu.birlesikgumrukleme.com.tr':
    'BiGU – Dış Ticaret Entegre Yönetim Platformu',
  localhost: 'Local – Dev Panel',
  '127.0.0.1': 'Local – Dev Panel',
};

export default DOMAIN_TITLE_MAP;
